import SettingProfile from "@/views/Setting/SettingProfile";
import SettingAuthentication from "@/views/Setting/SettingAuthentication";
import SettingWithdrawal from "@/views/Setting/SettingWithdrawal";
import Wallet from "@/views/Wallet/Wallet";

export default [
  {
    path: "setting",
    name: "Setting",
    component: { render: h => h("router-view") },
    meta: {
      nav: {
        icon: "el-icon-s-tools",
        title: "个人设置"
      },
      breadcrumb: {
        title: "个人设置",
        replace: false
      }
    },
    children: [
      {
        path: "profile",
        name: "SettingProfile",
        redirect: { name: "SettingProfile" },
        component: { render: h => h("router-view") },
        children: [
          {
            path: "",
            name: "SettingProfileSelf",
            component: SettingProfile,
            permission: "",
            meta: {
              title: "极客-个人设置-个人资料",
              nav: {
                title: "个人资料"
              },
              breadcrumb: {
                title: "个人资料",
                replace: false
              }
            }
          }
        ]
      },
      {
        path: "wallet",
        name: "Wallet",
        redirect: { name: "WalletSelf" },
        component: { render: h => h("router-view") },
        children: [
          {
            path: "",
            name: "WalletSelf",
            component: Wallet,
            permission: "expert_service.api.fuwu_admin.wallets.balance",
            meta: {
              title: "极客-我的钱包",
              nav: {
                icon: "el-icon-s-finance",
                title: "我的钱包"
              },
              breadcrumb: {
                title: "我的钱包",
                replace: false
              }
            }
          }
        ]
      },
      {
        path: "authentication",
        name: "SettingAuthentication",
        redirect: { name: "SettingAuthentication" },
        component: { render: h => h("router-view") },
        children: [
          {
            path: "",
            name: "SettingAuthenticationSelf",
            component: SettingAuthentication,
            permission: "",
            meta: {
              title: "极客-个人设置-实名认证",
              breadcrumb: {
                title: "实名认证",
                replace: false
              }
              // nav: {
              //   title: "实名认证"
              // }
            }
          }
        ]
      },
      {
        path: "withdrawal",
        name: "SettingWithdrawal",
        redirect: { name: "SettingWithdrawalSelf" },
        component: { render: h => h("router-view") },
        children: [
          {
            path: "",
            name: "SettingWithdrawalSelf",
            permission:
              "expert_service.api.fuwu_admin.wallets.user_bankaccount",
            component: SettingWithdrawal,
            meta: {
              title: "极客-个人设置-提现设置",
              breadcrumb: {
                title: "提现设置",
                replace: false
              }
              // nav: {
              //   title: "提现设置"
              // }
            }
          }
        ]
      }
    ]
  }
];
